module.exports = __webpack_public_path__ + "img/业务同步.56ba0ffe.svg";